/**
 * BUSINESS LOGIC: DANCE CAM (BÁILELE) OVERLAY
 */
import { 
    GetDanceConfig as DLGetDanceConfig,
    SetDanceConfig as DLSetDanceConfig,
    ShowDanceOverlay as DLShowDanceOverlay,
    HideDanceOverlay as DLHideDanceOverlay,
    TriggerExplosion as DLTriggerExplosion,
    ToggleFiestaMode as DLToggleFiestaMode,
    TriggerDancers as DLTriggerDancers
} from './../DL/Dance'

export const GetDanceConfig = async () => {
    return await DLGetDanceConfig();
};

export const SetDanceConfig = async (config) => {
    // Validar rangos numéricos
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.titleSize < 0.5) config.titleSize = 0.5;
    if (config.bpm < 30) config.bpm = 30;
    if (config.bpm > 300) config.bpm = 300;
    if (config.frameZoom < 20) config.frameZoom = 20;
    if (config.frameZoom > 100) config.frameZoom = 100;
    if (config.shapeOpacity < 0) config.shapeOpacity = 0;
    if (config.shapeOpacity > 1) config.shapeOpacity = 1;

    return await DLSetDanceConfig(config);
};

export const ShowDanceOverlay = async () => {
    return await DLShowDanceOverlay();
};

export const HideDanceOverlay = async () => {
    return await DLHideDanceOverlay();
};

export const TriggerExplosion = async () => {
    return await DLTriggerExplosion();
};

export const ToggleFiestaMode = async (state) => {
    return await DLToggleFiestaMode(state);
};

export const TriggerDancers = async (isFast) => {
    return await DLTriggerDancers(isFast);
};

